/* eslint-disable no-unused-expressions */
/* eslint-disable camelcase */
/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import { Button, Dropdown, Row, Table, Input, notification, Col, Empty, DatePicker } from 'antd';
import { DeleteOutlined, EditOutlined, MoreOutlined, PlusOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import styled, { css } from 'styled-components';
import NoData, { Wrapper } from '../../DailyLogsNew/components/NoData';
import { ReactComponent as Filter } from '../../../fonts/filter.svg';
import showNotification from '../../../components/ShowNotification';
import { DocIcons } from '../../ProjectDocumentNew/DocumentIcons';
import { NewMasterScheduleIcon, UploadMasterScheduleIcon } from './ScheduleSourceIcons';

const { Search } = Input;
const dateFormat = 'MM/DD/YYYY';
const getMasterScheduleGanttUrl = (projectId, scheduleId, scheduleName = '') => {
  const params = new URLSearchParams({
    tab: 'master-list',
    view: 'gantt',
    parentScheduleId: `${scheduleId}`,
    parentScheduleName: scheduleName
  });

  return `/schedule/${projectId}?${params.toString()}`;
};

const getMasterScheduleViewUrl = (projectId, scheduleId) =>
  `/schedule/${projectId}/master_schedule/${scheduleId}`;

const getMasterScheduleRouteBySource = (projectId, record) => {
  if (record?.source === 'uploaded') {
    return getMasterScheduleViewUrl(projectId, record.id);
  }

  return getMasterScheduleGanttUrl(projectId, record.id, record.name);
};

export const RevisionNumber = styled.div`
  display: inline;
  padding: 6px 8px;
  border-radius: 4px;
  background: #ececec;
  color: #909090;
  font-size: 14px;
  font-weight: 500;
  width: auto;
  ${(props) =>
    props.isCurrent &&
    css`
      background: #ffebe0;
      color: #fc8543;
    `}
`;

export const ActionItem = styled.div`
  &.dif-pad {
    padding: 10px 0 !important;
    display: inline;
  }
  padding: 10px !important;
  display: flex;
  align-items: center;
  svg {
    margin-right: 5px;
    width: 20px;
  }
`;
const List = ({
  projectId,
  filterState,
  setFilterState,
  dataSource,
  isLoading,
  mutate,
  permissionMutate,
  refetch,
  isFetching,
  isLookahead,
  totalCount,
  triggerParentButtonClick,
  onEdit,
  sortState = {},
  setSortState = () => {}
}) => {
  const navigate = useNavigate();
  const handleOnFilterChange = (e, name) => {
    if (name && (e === null || typeof e === 'undefined')) {
      setFilterState((pre) => ({
        ...pre,
        [name]: undefined,
        page: 1
      }));
      return;
    }
    if (typeof e === 'string' || typeof e === 'number') {
      setFilterState((pre) => ({
        ...pre,
        [name]: !e || e === 'All' ? undefined : e,
        page: 1
      }));
      return;
    }
    if (Array.isArray(e)) {
      const dateFilters = ['created_at', 'start_date', 'end_date'];
      if (dateFilters.includes(name)) {
        setFilterState((pre) => ({
          ...pre,
          [name]: !e?.[0] || !e?.[1] ? undefined : { start: e[0], end: e[1] },
          page: 1
        }));
        return;
      }
    }
    setFilterState((pre) => ({
      ...pre,
      [e.target.id]: e.target.value || undefined,
      page: 1
    }));
  };

  if (isLoading) {
    return <NoData onlySpinner />;
  }

  let locale = {};
  if (dataSource.length === 0) {
    const state = filterState;
    delete state?.page;
    delete state?.per_page;
    console.log(state, Object.keys(state).length);
    Object.keys(state).length ? (
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No Tasks Available" />
    ) : null;
    locale = Object.keys(state).length
      ? {
          emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No Tasks Available" />
        }
      : {
          emptyText: (
            <Wrapper autoWidth>
              <svg
                width="385"
                height="258"
                viewBox="0 0 385 258"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_6960_94997)">
                  <path
                    d="M175.011 21.7044C172.514 19.1935 168.462 19.1892 165.959 21.6959C165.772 21.8834 165.603 22.0808 165.444 22.2838C163.179 20.9106 160.752 19.9097 158.25 19.2851C158.281 19.0285 158.302 18.7705 158.303 18.5055C158.308 14.9569 155.445 12.078 151.91 12.0752C148.374 12.0724 145.505 14.9456 145.501 18.4942C145.501 18.7592 145.52 19.0172 145.551 19.2738C143.048 19.8941 140.618 20.8909 138.35 22.2599C138.191 22.0568 138.024 21.8581 137.837 21.672C135.34 19.161 131.287 19.1568 128.784 21.6635C126.281 24.1702 126.276 28.239 128.773 30.7499C128.959 30.9374 129.157 31.1052 129.359 31.2645C127.989 33.5399 126.992 35.9747 126.369 38.4871C126.113 38.456 125.856 38.4349 125.592 38.4349C122.056 38.4321 119.187 41.3053 119.183 44.8539C119.178 48.4024 122.041 51.2813 125.576 51.2841C125.84 51.2841 126.097 51.2644 126.353 51.2334C126.97 53.7457 127.963 56.1847 129.325 58.4616C129.123 58.6209 128.925 58.7887 128.738 58.9762C126.235 61.4829 126.229 65.5517 128.727 68.0626C131.224 70.5735 135.276 70.5778 137.779 68.0711C137.966 67.8836 138.135 67.6862 138.294 67.4832C140.559 68.8563 142.986 69.8573 145.488 70.4819C145.457 70.7385 145.436 70.9965 145.435 71.2615C145.43 74.8101 148.293 77.689 151.828 77.6918C155.364 77.6946 158.233 74.8214 158.237 71.2728C158.237 71.0078 158.218 70.7498 158.187 70.4932C160.69 69.8728 163.12 68.8761 165.388 67.5071C165.547 67.7101 165.714 67.9089 165.901 68.095C168.398 70.606 172.451 70.6102 174.954 68.1035C177.457 65.5968 177.462 61.528 174.965 59.0171C174.779 58.8296 174.581 58.6618 174.379 58.5025C175.749 56.227 176.746 53.7922 177.369 51.2799C177.625 51.3109 177.882 51.3321 178.146 51.3321C181.682 51.3349 184.551 48.4617 184.555 44.9131C184.56 41.3645 181.697 38.4857 178.162 38.4828C177.898 38.4828 177.641 38.5026 177.385 38.5336C176.767 36.0213 175.775 33.5822 174.411 31.3054C174.614 31.146 174.812 30.9783 174.998 30.7908C177.501 28.2841 177.507 24.2153 175.01 21.7044H175.011ZM160.285 36.4541C164.922 41.1178 164.912 48.6731 160.264 53.3284C155.616 57.9837 148.089 57.9766 143.453 53.3129C138.816 48.6492 138.826 41.0939 143.474 36.4386C148.122 31.7833 155.649 31.7903 160.285 36.4541Z"
                    fill="#FFEBE0"
                  />
                  <path
                    d="M362.871 236.212V56.6684C362.871 50.1592 357.606 44.8835 351.111 44.8835H117.155C110.66 44.8835 105.396 50.1606 105.396 56.6684V224.428C105.396 230.937 110.66 236.212 117.155 236.212H362.871Z"
                    fill="white"
                  />
                  <path
                    d="M362.871 236.523C362.699 236.523 362.562 236.383 362.562 236.212V56.6684C362.562 50.3411 357.425 45.1938 351.111 45.1938H117.155C110.841 45.1938 105.704 50.3411 105.704 56.6684V224.428C105.704 230.755 110.841 235.902 117.155 235.902C117.326 235.902 117.464 236.042 117.464 236.212C117.464 236.383 117.325 236.523 117.155 236.523C110.5 236.523 105.085 231.096 105.085 224.426V56.6684C105.085 49.9985 110.5 44.572 117.155 44.572H351.111C357.766 44.572 363.181 49.9985 363.181 56.6684V236.212C363.181 236.384 363.042 236.523 362.872 236.523H362.871Z"
                    fill="#3B3B3C"
                  />
                  <path
                    d="M350.173 231.739H117.155C113.132 231.739 109.859 228.458 109.859 224.426V56.6684C109.859 52.6363 113.132 49.3556 117.155 49.3556H351.112C355.134 49.3556 358.408 52.6363 358.408 56.6684V223.486C358.408 228.037 354.714 231.739 350.173 231.739ZM117.155 49.9773C113.473 49.9773 110.479 52.9789 110.479 56.6684V224.428C110.479 228.117 113.473 231.119 117.155 231.119H350.173C354.373 231.119 357.789 227.696 357.789 223.487V56.6684C357.789 52.9789 354.794 49.9773 351.112 49.9773H117.155Z"
                    fill="#3B3B3C"
                  />
                  <path
                    d="M344.008 254.89H59.2544C48.8365 254.89 40.3906 246.413 40.3906 235.956H362.871C362.871 246.413 354.425 254.89 344.007 254.89H344.008Z"
                    fill="white"
                  />
                  <path
                    d="M344.009 255.202H59.2548C48.6824 255.202 40.082 246.569 40.082 235.957C40.082 235.785 40.2211 235.647 40.391 235.647H362.871C363.042 235.647 363.18 235.787 363.18 235.957C363.18 246.569 354.58 255.202 344.007 255.202H344.009ZM40.7043 236.267C40.87 246.393 49.129 254.58 59.2562 254.58H344.01C354.137 254.58 362.395 246.393 362.562 236.267H40.7043Z"
                    fill="#3B3B3C"
                  />
                  <path
                    d="M154.806 86.8995H124.686C123.851 86.8995 123.175 87.5787 123.175 88.4165V94.7312C123.175 95.569 123.851 96.2482 124.686 96.2482H154.806C155.641 96.2482 156.318 95.569 156.318 94.7312V88.4165C156.318 87.5787 155.641 86.8995 154.806 86.8995Z"
                    fill="#FFDBC6"
                  />
                  <path
                    d="M124.352 108.837H154.472C155.307 108.837 155.984 109.516 155.984 110.354V116.667C155.984 117.504 155.307 118.184 154.472 118.184H124.352C123.518 118.184 122.841 117.504 122.841 116.667V110.354C122.841 109.516 123.518 108.837 124.352 108.837Z"
                    fill="#FFDBC6"
                  />
                  <path
                    d="M154.472 128.78H124.352C123.517 128.78 122.841 129.459 122.841 130.297V136.612C122.841 137.45 123.517 138.129 124.352 138.129H154.472C155.307 138.129 155.984 137.45 155.984 136.612V130.297C155.984 129.459 155.307 128.78 154.472 128.78Z"
                    fill="#FFDBC6"
                  />
                  <path
                    d="M243.831 86.8995H175.463C174.628 86.8995 173.951 87.5787 173.951 88.4165V94.7312C173.951 95.569 174.628 96.2482 175.463 96.2482H243.831C244.666 96.2482 245.343 95.569 245.343 94.7312V88.4165C245.343 87.5787 244.666 86.8995 243.831 86.8995Z"
                    fill="#FFDBC6"
                  />
                  <path
                    d="M203.902 108.837H175.129C174.294 108.837 173.617 109.516 173.617 110.354V116.668C173.617 117.506 174.294 118.185 175.129 118.185H203.902C204.736 118.185 205.413 117.506 205.413 116.668V110.354C205.413 109.516 204.736 108.837 203.902 108.837Z"
                    fill="#FFDBC6"
                  />
                  <path
                    d="M219.758 128.78H175.129C174.294 128.78 173.617 129.459 173.617 130.297V136.612C173.617 137.45 174.294 138.129 175.129 138.129H219.758C220.593 138.129 221.27 137.45 221.27 136.612V130.297C221.27 129.459 220.593 128.78 219.758 128.78Z"
                    fill="#FFDBC6"
                  />
                  <path
                    d="M154.806 149.097H124.686C123.851 149.097 123.175 149.776 123.175 150.614V156.929C123.175 157.767 123.851 158.446 124.686 158.446H154.806C155.641 158.446 156.318 157.767 156.318 156.929V150.614C156.318 149.776 155.641 149.097 154.806 149.097Z"
                    fill="#FFDBC6"
                  />
                  <path
                    d="M275.585 149.097H175.463C174.628 149.097 173.951 149.776 173.951 150.614V156.929C173.951 157.767 174.628 158.446 175.463 158.446H275.585C276.42 158.446 277.096 157.767 277.096 156.929V150.614C277.096 149.776 276.42 149.097 275.585 149.097Z"
                    fill="#FFDBC6"
                  />
                  <path
                    d="M345.239 149.097H286.45C285.615 149.097 284.938 149.776 284.938 150.614V156.929C284.938 157.767 285.615 158.446 286.45 158.446H345.239C346.074 158.446 346.751 157.767 346.751 156.929V150.614C346.751 149.776 346.074 149.097 345.239 149.097Z"
                    fill="#FFDBC6"
                  />
                  <path
                    d="M345.237 86.8995H254.043C253.208 86.8995 252.531 87.5787 252.531 88.4165V94.7312C252.531 95.569 253.208 96.2482 254.043 96.2482H345.237C346.072 96.2482 346.749 95.569 346.749 94.7312V88.4165C346.749 87.5787 346.072 86.8995 345.237 86.8995Z"
                    fill="#FFDBC6"
                  />
                  <path
                    d="M298.777 108.837H214.766C213.932 108.837 213.255 109.516 213.255 110.354V116.668C213.255 117.506 213.932 118.185 214.766 118.185H298.777C299.611 118.185 300.288 117.506 300.288 116.668V110.354C300.288 109.516 299.611 108.837 298.777 108.837Z"
                    fill="#FFDBC6"
                  />
                  <path
                    d="M318.852 128.78H230.621C229.786 128.78 229.109 129.459 229.109 130.297V136.612C229.109 137.45 229.786 138.129 230.621 138.129H318.852C319.687 138.129 320.363 137.45 320.363 136.612V130.297C320.363 129.459 319.687 128.78 318.852 128.78Z"
                    fill="#FFDBC6"
                  />
                  <path
                    d="M125.021 169.677H155.141C155.976 169.677 156.653 170.356 156.653 171.194V177.507C156.653 178.344 155.976 179.024 155.141 179.024H125.021C124.187 179.024 123.51 178.344 123.51 177.507V171.194C123.51 170.356 124.187 169.677 125.021 169.677Z"
                    fill="#FFDBC6"
                  />
                  <path
                    d="M155.44 187.892H125.32C124.485 187.892 123.809 188.571 123.809 189.409V195.723C123.809 196.561 124.485 197.24 125.32 197.24H155.44C156.275 197.24 156.951 196.561 156.951 195.723V189.409C156.951 188.571 156.275 187.892 155.44 187.892Z"
                    fill="#FFDBC6"
                  />
                  <path
                    d="M275.918 169.677H175.796C174.961 169.677 174.284 170.356 174.284 171.194V177.508C174.284 178.346 174.961 179.025 175.796 179.025H275.918C276.753 179.025 277.429 178.346 277.429 177.508V171.194C277.429 170.356 276.753 169.677 275.918 169.677Z"
                    fill="#FFDBC6"
                  />
                  <path
                    d="M220.726 187.892H176.096C175.262 187.892 174.585 188.571 174.585 189.409V195.723C174.585 196.561 175.262 197.24 176.096 197.24H220.726C221.561 197.24 222.237 196.561 222.237 195.723V189.409C222.237 188.571 221.561 187.892 220.726 187.892Z"
                    fill="#FFDBC6"
                  />
                  <path
                    d="M345.572 169.677H286.783C285.948 169.677 285.271 170.356 285.271 171.194V177.508C285.271 178.346 285.948 179.025 286.783 179.025H345.572C346.407 179.025 347.084 178.346 347.084 177.508V171.194C347.084 170.356 346.407 169.677 345.572 169.677Z"
                    fill="#FFDBC6"
                  />
                  <path
                    d="M319.82 187.892H231.588C230.754 187.892 230.077 188.571 230.077 189.409V195.723C230.077 196.561 230.754 197.24 231.588 197.24H319.82C320.654 197.24 321.331 196.561 321.331 195.723V189.409C321.331 188.571 320.654 187.892 319.82 187.892Z"
                    fill="#FFDBC6"
                  />
                  <path
                    d="M190.259 67.6214C190.252 67.252 190.248 66.8854 190.249 66.5132C190.268 52.859 195.581 40.0281 205.214 30.3848C214.847 20.7415 227.642 15.4419 241.247 15.4603C254.851 15.4786 267.634 20.812 277.242 30.4806C286.849 40.1493 292.129 52.9915 292.112 66.6486C292.076 94.8368 269.197 117.74 241.114 117.702C213.401 117.665 190.814 95.2979 190.261 67.6214H190.259ZM285.599 65.5616C285.367 53.9685 280.783 43.1029 272.623 34.8666C264.235 26.3992 253.074 21.727 241.197 21.7101C216.677 21.6762 196.703 41.7325 196.673 66.4188C196.646 91.1036 216.564 111.218 241.084 111.252C265.604 111.285 285.578 91.2291 285.609 66.5428C285.609 66.2158 285.606 65.8873 285.599 65.5616Z"
                    fill="#3B3B3C"
                  />
                  <path
                    d="M138.827 148.251C138.089 147.219 138.323 145.783 139.351 145.041L203.564 99.3187L206.238 103.055L142.026 148.777C140.998 149.519 139.566 149.283 138.827 148.251Z"
                    fill="#3B3B3C"
                  />
                  <mask
                    id="mask0_6960_94997"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="239"
                    height="258">
                    <path d="M238.235 0.181885H0.130859V258H238.235V0.181885Z" fill="white" />
                  </mask>
                  <g mask="url(#mask0_6960_94997)">
                    <path
                      d="M67.0303 45.3586L53.2441 67.6876L70.4884 74.8087L84.2394 48.7874L67.0303 45.3586Z"
                      fill="white"
                    />
                    <path
                      d="M56.6703 62.4402C56.6141 62.4402 56.558 62.4247 56.5074 62.3937C56.3627 62.3035 56.3178 62.1117 56.4077 61.9651L65.3704 47.4579C65.4603 47.3127 65.6513 47.2676 65.7974 47.3578C65.9421 47.448 65.987 47.6398 65.8971 47.7864L56.9344 62.2936C56.8754 62.3881 56.7743 62.4402 56.6703 62.4402Z"
                      fill="#3B3B3C"
                    />
                    <path
                      d="M72.6167 70.2958C72.5661 70.2958 72.5142 70.2831 72.4664 70.2564C72.3161 70.1732 72.2628 69.9843 72.3456 69.8334L81.4193 53.4032C81.5022 53.2523 81.6904 53.1988 81.8407 53.2819C81.991 53.3651 82.0444 53.554 81.9615 53.7049L72.8878 70.1351C72.8316 70.238 72.7249 70.2958 72.6167 70.2958Z"
                      fill="#3B3B3C"
                    />
                    <path
                      d="M60.4945 35.6434C60.2065 30.8232 61.68 25.9184 64.5762 22.0568C65.8165 20.4031 67.3447 18.9129 69.2226 18.0515C71.1006 17.1901 73.3634 17.0265 75.2132 17.9444C75.2315 17.9542 75.2498 17.9627 75.268 17.9725C77.3131 19.0201 79.8007 18.8466 81.5129 17.3127C82.6183 16.3245 83.9063 15.5434 85.3053 15.0514C88.8406 13.8093 92.9758 14.4451 95.9746 16.6938C98.9734 18.9425 100.749 22.7364 100.552 26.4823C100.298 31.3491 97.0028 35.5405 93.2862 38.6859C89.5696 41.8312 85.2575 44.3097 80.5914 45.6942C76.8018 46.8192 72.7777 47.2097 68.8504 46.7121C67.0778 46.4879 65.7406 46.3441 64.4288 45.0865C63.27 43.9756 62.3879 42.5982 61.7572 41.1263C61.0142 39.3964 60.6082 37.5213 60.4959 35.6434H60.4945Z"
                      fill="#3B3B3C"
                    />
                    <path
                      d="M71.3948 51.9129C69.7683 52.646 67.7358 52.2428 66.4127 51.0459C65.0896 49.8489 64.4828 47.9541 64.7174 46.1833C64.8382 45.2796 65.1893 44.3646 65.8888 43.781C66.792 43.0281 68.1362 42.9717 69.2219 43.4186C70.3077 43.867 71.1645 44.7467 71.8373 45.7096C71.8373 45.7096 72.8486 44.7425 76.0131 41.8171C79.5949 38.5068 74.4035 32.8829 74.4035 32.8829C79.6749 35.2543 84.7862 35.36 89.7388 33.2298C92.4652 37.4071 93.5425 42.6305 92.6913 47.5466C92.1955 50.4114 91.0016 53.2522 88.8231 55.1753C86.3341 57.3704 82.7425 58.1204 79.4979 57.431C76.2533 56.7416 73.3753 54.7128 71.3386 52.0919L71.3934 51.9115L71.3948 51.9129Z"
                      fill="white"
                    />
                    <path
                      d="M81.8561 57.9893C81.0498 57.9893 80.2366 57.9061 79.4345 57.7355C76.2868 57.0672 73.3456 55.1541 71.1432 52.3443C69.5167 52.8955 67.5404 52.4839 66.2046 51.2756C64.8408 50.042 64.1525 48.0739 64.4096 46.141C64.5135 45.3557 64.8211 44.2659 65.6906 43.5413C66.6232 42.7631 68.0573 42.6009 69.3397 43.131C70.2569 43.5089 71.1109 44.218 71.882 45.2415C72.3526 44.796 73.524 43.6964 75.805 41.5887C76.534 40.9148 76.9231 40.0815 76.9625 39.113C77.0762 36.2722 74.208 33.1254 74.1785 33.0944C74.0788 32.9858 74.069 32.8223 74.1546 32.7025C74.2403 32.5826 74.3991 32.5389 74.5325 32.5995C79.686 34.9173 84.7622 35.0343 89.6193 32.9435C89.7555 32.8843 89.917 32.9323 89.9999 33.0592C92.7698 37.3042 93.8626 42.6037 92.9987 47.6002C92.597 49.9194 91.5829 53.1564 89.0293 55.4093C87.1402 57.0771 84.5318 57.9893 81.8561 57.9893ZM71.6826 52.0271C73.7895 54.6846 76.5818 56.4934 79.5638 57.1279C82.8351 57.8243 86.3058 56.9855 88.6206 54.9426C91.0379 52.8095 92.0043 49.715 92.3877 47.4945C93.2108 42.7363 92.2037 37.6947 89.6221 33.6174C85.0347 35.5221 80.2675 35.5306 75.4286 33.6485C76.3318 34.8623 77.6661 37.0292 77.5819 39.137C77.5369 40.2775 77.0804 41.2559 76.225 42.0454C73.0998 44.9342 72.0632 45.9253 72.0534 45.9352C71.9888 45.9972 71.9017 46.0282 71.809 46.0198C71.7191 46.0113 71.6376 45.9634 71.5857 45.8887C70.83 44.8073 69.9956 44.0728 69.1051 43.7062C68.032 43.2635 66.8465 43.3862 66.0881 44.0206C65.529 44.4859 65.1526 45.2683 65.0248 46.2242C64.7944 47.9569 65.4054 49.7164 66.6204 50.8146C67.8831 51.958 69.7948 52.2921 71.2682 51.6295C71.4241 51.559 71.6081 51.6295 71.677 51.786C71.7121 51.8664 71.7121 51.9524 71.6826 52.0285V52.0271Z"
                      fill="#3B3B3C"
                    />
                    <path
                      d="M71.5275 49.0736C71.4629 49.0736 71.3969 49.0538 71.3407 49.0101C70.467 48.3475 69.3841 47.9387 68.2913 47.8597C68.1213 47.847 67.9921 47.699 68.0048 47.527C68.0174 47.3564 68.1705 47.2267 68.3363 47.2394C69.547 47.3268 70.7465 47.7808 71.7143 48.5139C71.8505 48.6168 71.8772 48.8128 71.7747 48.9495C71.7143 49.0299 71.6216 49.0736 71.5275 49.0736Z"
                      fill="#3B3B3C"
                    />
                    <path
                      d="M90.4864 33.1692C90.3852 33.1692 90.2869 33.1199 90.2265 33.0282C90.1324 32.8844 90.1731 32.6913 90.3164 32.5982C92.1789 31.3731 93.5371 29.4233 94.0428 27.2493C94.0821 27.083 94.2451 26.9786 94.415 27.0181C94.5807 27.0576 94.6847 27.224 94.6454 27.3917C94.1046 29.7194 92.6508 31.8059 90.6549 33.1185C90.6029 33.1537 90.5439 33.1692 90.4849 33.1692H90.4864Z"
                      fill="#3B3B3C"
                    />
                    <path
                      d="M14.4986 159.505C14.4986 159.505 -14.4825 280.729 -67.5144 334.568C-72.0527 339.175 -74.175 345.632 -73.2044 352.03C-70.4093 370.455 -60.8482 407.475 -28.3809 427.867C-24.7922 430.121 -20.1823 427.251 -20.6177 423.031L-23.8062 392.099C-23.8062 392.099 -3.62492 369.545 8.05711 357.305C8.05711 357.305 7.96864 396.404 8.95887 419.002C9.29317 426.645 15.5703 432.672 23.2113 432.672H93.1293C96.4428 432.672 98.2533 428.803 96.1338 426.254L77.8586 404.273C77.8586 404.273 82.0822 235.696 89.5504 159.505H14.4972H14.4986Z"
                      fill="white"
                    />
                    <path
                      d="M93.1303 432.982H23.2123C15.3901 432.982 8.99355 426.848 8.65083 419.016C7.74767 398.42 7.74345 363.702 7.74767 358.08C-3.46243 369.865 -22.0101 390.56 -23.4835 392.205L-20.3092 423C-20.0956 425.067 -21.0578 427.035 -22.8178 428.136C-24.5862 429.243 -26.7801 429.24 -28.5457 428.132C-42.7841 419.189 -54.1066 406.14 -62.1998 389.347C-69.0262 375.184 -72.1191 361.262 -73.5125 352.078C-74.4887 345.641 -72.3298 339.013 -67.7368 334.351C-40.3822 306.58 -19.5633 260.507 -6.91492 226.747C6.79536 190.152 14.1231 159.737 14.1962 159.434C14.2355 159.266 14.4041 159.163 14.5698 159.204C14.7355 159.244 14.8381 159.412 14.7987 159.579C14.7257 159.882 7.39091 190.328 -6.33201 226.958C-14.3916 248.475 -23.0467 267.886 -32.0558 284.651C-43.3221 305.619 -55.1783 322.489 -67.2957 334.789C-71.7511 339.312 -73.8468 345.741 -72.9001 351.985C-69.9223 371.616 -60.1576 407.544 -28.2184 427.606C-26.6551 428.587 -24.7112 428.59 -23.1464 427.61C-21.5649 426.622 -20.7361 424.923 -20.9272 423.066L-24.1156 392.135C-24.124 392.047 -24.0959 391.96 -24.0384 391.895C-23.8361 391.669 -3.72086 369.197 7.83195 357.093C7.91903 357.001 8.05387 356.972 8.17185 357.02C8.28984 357.068 8.36569 357.182 8.36569 357.309C8.36569 357.699 8.28703 396.659 9.26603 418.992C9.59471 426.491 15.7188 432.364 23.2081 432.364H93.1261C94.5405 432.364 95.7892 431.568 96.3876 430.285C96.9831 429.007 96.7935 427.54 95.8917 426.457L77.6165 404.476C77.5688 404.418 77.5421 404.345 77.5449 404.269C77.5898 402.566 82.0663 233.099 89.4517 157.768C89.4685 157.597 89.6174 157.473 89.7902 157.488C89.9601 157.505 90.0851 157.658 90.0683 157.828C82.7672 232.306 78.309 398.85 78.1685 404.168L96.3693 426.058C97.4256 427.328 97.6489 429.05 96.9508 430.548C96.2499 432.053 94.7849 432.986 93.1275 432.986L93.1303 432.982Z"
                      fill="#3B3B3C"
                    />
                    <path
                      d="M8.05811 357.615C7.98648 357.615 7.91344 357.589 7.85585 357.539C7.72663 357.426 7.71259 357.23 7.82495 357.1C39.2865 320.724 53.9238 277.229 60.6617 247.147C67.9656 214.542 67.8223 190.231 67.8195 189.989C67.8195 189.885 67.8701 189.786 67.9571 189.729L77.1011 183.594C77.2443 183.499 77.4354 183.538 77.5309 183.68C77.6264 183.823 77.5871 184.016 77.4452 184.112L68.4389 190.153C68.4389 192.372 68.2648 216.024 61.2685 247.267C56.9704 266.455 50.9784 284.714 43.4582 301.536C34.0558 322.566 22.2235 341.399 8.28988 357.508C8.22948 357.578 8.14239 357.615 8.05671 357.615H8.05811Z"
                      fill="#3B3B3C"
                    />
                    <path
                      d="M8.89203 159.574L84.1812 158.268L88.6015 120.43L95.2621 111.476C95.2621 111.476 76.6175 55.3431 52.405 62.1724C26.6925 69.4246 8.89062 159.574 8.89062 159.574H8.89203Z"
                      fill="#FC8543"
                    />
                    <path
                      d="M62.0414 132.447C62.0414 132.447 76.7125 150.772 82.9573 156.434C93.7909 166.256 109.899 167.793 122.575 160.228L164.965 134.93C166.611 133.947 168.639 133.817 170.367 134.621C173.96 136.293 180.321 138.25 182.817 132.73C182.817 132.73 188.146 131.741 187.836 127.776C187.836 127.776 192.755 126.485 192.434 122.792C192.434 122.792 195.256 122.315 195.106 119.368C194.956 116.42 184.462 99.5668 162.633 104.996C151.103 107.864 137.253 113.607 126.056 118.828C100.353 130.812 99.4445 117.905 94.7742 111.373C94.7742 111.373 78.7449 115.178 62.04 132.448L62.0414 132.447Z"
                      fill="white"
                    />
                    <path
                      d="M105.165 165.399C100.579 165.399 96.0271 164.446 91.8077 162.517C84.0979 158.996 82.0261 158.048 61.7999 132.642C61.6932 132.508 61.7156 132.312 61.8491 132.205C61.9825 132.097 62.1777 132.12 62.2845 132.254C82.4194 157.545 84.4631 158.478 92.0647 161.952C101.647 166.33 112.993 165.585 122.418 159.961L164.807 134.663C166.559 133.617 168.687 133.496 170.497 134.339C173.031 135.518 176.636 136.705 179.421 135.666C180.8 135.153 181.848 134.121 182.535 132.601C182.577 132.508 182.661 132.441 182.761 132.423C182.812 132.413 187.812 131.436 187.527 127.799C187.516 127.649 187.612 127.513 187.757 127.473C187.803 127.46 192.42 126.203 192.127 122.818C192.113 122.656 192.225 122.512 192.384 122.484C192.486 122.465 194.93 122.009 194.797 119.381C194.731 118.074 192.338 113.129 187.082 109.214C182.581 105.862 174.825 102.461 163.434 105.294C150.725 108.454 136.11 113.874 126.199 119.099C116.822 124.043 109.834 125.545 104.835 123.686C100.484 122.069 98.3756 118.243 96.5173 114.866C95.8459 113.648 95.2125 112.496 94.5242 111.55C94.4231 111.412 94.454 111.218 94.5916 111.116C94.7293 111.015 94.9231 111.046 95.0242 111.184C95.7364 112.161 96.3783 113.33 97.0595 114.565C100.71 121.194 105.253 129.441 125.911 118.547C135.861 113.3 150.531 107.861 163.285 104.689C174.909 101.799 182.842 105.282 187.45 108.714C192.588 112.54 195.325 117.593 195.415 119.347C195.548 121.964 193.509 122.805 192.757 123.027C192.836 126.251 189.15 127.673 188.156 127.998C188.24 131.591 183.924 132.787 183.032 132.995C182.274 134.594 181.132 135.687 179.636 136.244C176.65 137.358 172.875 136.125 170.235 134.897C168.61 134.142 166.698 134.252 165.122 135.192L122.733 160.49C117.28 163.744 111.194 165.394 105.164 165.394L105.165 165.399Z"
                      fill="#3B3B3C"
                    />
                    <path
                      d="M182.482 132.042C182.355 132.042 182.237 131.965 182.191 131.839C181.362 129.574 179.766 127.645 177.698 126.41C177.55 126.323 177.502 126.131 177.589 125.984C177.676 125.838 177.866 125.788 178.014 125.876C180.205 127.184 181.894 129.226 182.771 131.625C182.83 131.786 182.747 131.965 182.587 132.024C182.552 132.037 182.515 132.044 182.48 132.044L182.482 132.042Z"
                      fill="#3B3B3C"
                    />
                    <path
                      d="M187.482 127.308C187.35 127.308 187.227 127.222 187.185 127.09C186.264 124.088 184.226 121.39 181.592 119.685C181.449 119.592 181.407 119.399 181.499 119.255C181.592 119.111 181.783 119.071 181.928 119.162C184.681 120.944 186.813 123.767 187.777 126.906C187.827 127.07 187.734 127.245 187.572 127.296C187.541 127.305 187.511 127.31 187.48 127.31L187.482 127.308Z"
                      fill="#3B3B3C"
                    />
                    <path
                      d="M192.334 122.185C192.206 122.185 192.087 122.105 192.042 121.978C191.09 119.255 189.291 116.812 186.976 115.096C186.838 114.995 186.809 114.8 186.91 114.662C187.011 114.524 187.205 114.494 187.342 114.596C189.755 116.385 191.632 118.934 192.625 121.772C192.681 121.934 192.597 122.112 192.435 122.168C192.402 122.181 192.367 122.185 192.333 122.185H192.334Z"
                      fill="#3B3B3C"
                    />
                    <path
                      d="M59.7794 133.77C59.6656 133.77 59.5575 133.708 59.5027 133.599C54.3436 123.402 45.8655 104.585 45.7812 104.396C45.711 104.239 45.7812 104.054 45.9357 103.984C46.0916 103.913 46.2756 103.984 46.3458 104.139C46.4301 104.328 54.9026 123.132 60.0547 133.317C60.132 133.471 60.0716 133.657 59.9185 133.734C59.8735 133.757 59.8258 133.768 59.778 133.768L59.7794 133.77Z"
                      fill="#3B3B3C"
                    />
                  </g>
                </g>
                <defs>
                  <clipPath id="clip0_6960_94997">
                    <rect width="385" height="258" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <h2 style={{ fontWeight: 700 }}>{`No ${
                isLookahead ? 'Lookahead' : 'Master Schedule'
              } have been upload yet`}</h2>
              <p
                style={{
                  color: '#909090'
                }}>{isLookahead
                  ? 'Click on button to upload a new Lookahead'
                  : 'Click on button to create a new Master Schedule'}</p>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                key="2"
                className="pl-primary-btn"
                onClick={triggerParentButtonClick}>
                {isLookahead ? 'Upload Lookahead' : 'Create Master Schedule'}
              </Button>
            </Wrapper>
          )
        };
  }

  const handleItemDelete = (id) => {
    mutate(
      { payload: { id }, action: 'delete' },
      {
        onSuccess: () => {
          return Promise.all([refetch(), showNotification({ message: 'Deleted Successfully' })]);
        }
      }
    );
  };

  const handleChangeAccessibility = (data) => {
    permissionMutate(
      { payload: { id: data?.id, is_private: !data?.is_private }, action: 'put' },
      {
        onSuccess: () => {
          return Promise.all([
            refetch(),
            showNotification({ message: 'Action Changed Successfully' })
          ]);
        }
      }
    );
  };

  const items = (item, record) => {
    const options = [];
    item.allow_view &&
      options.push({
        label: (
          <ActionItem
            onClick={(e) => {
              e.preventDefault();
              const url = isLookahead
                ? `/schedule/${projectId}/lookahead/${record.id}`
                : getMasterScheduleRouteBySource(projectId, record);
              navigate(url);
            }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none">
              <rect width="24" height="24" transform="translate(0 0.000976562)" fill="white" />
              <path
                d="M12 14.001C13.1046 14.001 14 13.1055 14 12.001C14 10.8964 13.1046 10.001 12 10.001C10.8954 10.001 10 10.8964 10 12.001C10 13.1055 10.8954 14.001 12 14.001Z"
                stroke="#080808"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M22 12.001C19.333 16.668 16 19.001 12 19.001C8 19.001 4.667 16.668 2 12.001C4.667 7.33398 8 5.00098 12 5.00098C16 5.00098 19.333 7.33398 22 12.001Z"
                stroke="#080808"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            View
          </ActionItem>
        ),
        key: '1'
      });

    !isLookahead && item.allow_edit !== false &&
      options.push({
        label: (
          <ActionItem
            onClick={(e) => {
              e.preventDefault();
              onEdit?.(record);
            }}>
            <EditOutlined />
            Edit
          </ActionItem>
        ),
        key: '2'
      });

    options.push({
      label: (
        <ActionItem
          onClick={(e) => {
            e.preventDefault();
            handleChangeAccessibility(item);
          }}>
          {DocIcons[record?.is_private ? 'public' : 'private']}
          {`Mark as ${record?.is_private ? 'public' : 'private'}`}
        </ActionItem>
      ),
      key: '3'
    });

    item.allow_delete &&
      options.push({
        label: (
          <ActionItem
            style={{ color: '#D92929' }}
            onClick={(e) => {
              e.preventDefault();
              handleItemDelete(item.id);
            }}>
            {DocIcons.delete}
            Delete
          </ActionItem>
        ),
        key: '4'
      });
    return options;
  };

  const columns = [
    {
      title: () => (
        <>
          <Row align="middle" justify="space-between" wrap={false}>
            <div>{isLookahead ? 'Lookahead Name' : 'Master Schedule Name'}</div>
            <Filter />
          </Row>
          <Search
            id="name"
            style={{ width: '100%' }}
            onSearch={(value) => handleOnFilterChange(value, 'name')}
            placeholder="Search"
            loading={isFetching}
            allowClear
            onClick={(e) => e.stopPropagation()}
          />
        </>
      ),
      dataIndex: 'name',
      render: (text, record) => (
        <Link
          style={{ fontWeight: 700, color: '#FC8543', textDecoration: 'underline' }}
          to={
            isLookahead
              ? `/schedule/${projectId}/lookahead/${record.id}`
              : getMasterScheduleRouteBySource(projectId, record)
          }>
          <span className="d-flex align-items-center" style={{ gap: 8 }}>
            {record?.source === 'uploaded' ? <UploadMasterScheduleIcon /> : <NewMasterScheduleIcon />}
            <span>{text}</span>
            {record?.is_private && (
              <svg
                style={{ width: '20px' }}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none">
                <g clipPath="url(#clip0_13583_283499)">
                  <rect width="24" height="24" fill="white" />
                  <path
                    d="M17 11H7C5.89543 11 5 11.8954 5 13V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V13C19 11.8954 18.1046 11 17 11Z"
                    stroke="#FC8543"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z"
                    stroke="#FC8543"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8 11V7C8 5.93913 8.42143 4.92172 9.17157 4.17157C9.92172 3.42143 10.9391 3 12 3C13.0609 3 14.0783 3.42143 14.8284 4.17157C15.5786 4.92172 16 5.93913 16 7V11"
                    stroke="#FC8543"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_13583_283499">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            )}
          </span>
        </Link>
      ),
      sortOrder: sortState.attribute !== 'name' ? 'asc' : sortState.direction,
      onHeaderCell: (col) => ({
        style: { cursor: 'pointer' },
        onClick: () => {
          setSortState((pre) => ({
            ...pre,
            attribute: 'name',
            direction: pre.attribute !== 'name' ? 'asc' : col.sortOrder === 'asc' ? 'desc' : 'asc'
          }));
        }
      }),
      sortDirections: ['asc', 'desc', 'asc'],
      key: 'name',
      showSorterTooltip: false
    },
    {
      title: 'Duration',
      dataIndex: 'duration',
      render: (text) => text || '-',
      key: 'duration',
      showSorterTooltip: false
    },
    {
      title: () => (
        <>
          <Row align="middle" justify="space-between" wrap={false}>
            <div>Start Date</div>
            <Filter />
          </Row>
          <Row>
            <DatePicker.RangePicker
              id="start_date"
              separator={<span style={{ color: '#909090' }}>-</span>}
              style={{ width: '100%' }}
              format={dateFormat}
              onChange={(_, date) => handleOnFilterChange(date, 'start_date')}
              onClick={(e) => e.stopPropagation()}
            />
          </Row>
        </>
      ),
      sortOrder: sortState.attribute !== 'start_date' ? 'asc' : sortState.direction,
      onHeaderCell: (col) => ({
        style: { cursor: 'pointer' },
        onClick: () => {
          setSortState((pre) => ({
            ...pre,
            attribute: 'start_date',
            direction:
              pre.attribute !== 'start_date' ? 'asc' : col.sortOrder === 'asc' ? 'desc' : 'asc'
          }));
        }
      }),
      sortDirections: ['asc', 'desc', 'asc'],
      dataIndex: 'start_date',
      render: (text) => text || '-',
      key: 'start_date',
      showSorterTooltip: false
    },
    {
      title: () => (
        <>
          <Row align="middle" justify="space-between" wrap={false}>
            <div>End Date</div>
            <Filter />
          </Row>
          <Row>
            <DatePicker.RangePicker
              id="end_date"
              separator={<span style={{ color: '#909090' }}>-</span>}
              style={{ width: '100%' }}
              format={dateFormat}
              onChange={(_, date) => handleOnFilterChange(date, 'end_date')}
              onClick={(e) => e.stopPropagation()}
            />
          </Row>
        </>
      ),
      sortOrder: sortState.attribute !== 'end_date' ? 'asc' : sortState.direction,
      onHeaderCell: (col) => ({
        style: { cursor: 'pointer' },
        onClick: () => {
          setSortState((pre) => ({
            ...pre,
            attribute: 'end_date',
            direction: pre.attribute !== 'end_date' ? 'asc' : col.sortOrder === 'asc' ? 'desc' : 'asc'
          }));
        }
      }),
      sortDirections: ['asc', 'desc', 'asc'],
      dataIndex: 'end_date',
      render: (text) => text || '-',
      key: 'end_date',
      showSorterTooltip: false
    },
    {
      title: 'Current Revision No.',
      dataIndex: 'current_revision',
      render: (text) => <RevisionNumber>{text || ''}</RevisionNumber>,
      key: 'current_revision',
      showSorterTooltip: false
    },
    {
      title: () => (
        <>
          <Row align="middle" justify="space-between" wrap={false}>
            <div>Uploaded By</div>
          </Row>
        </>
      ),
      render: (item, record) => (
        <Col>
          <div>{record.uploaded_by}</div>
        </Col>
      ),
      dataIndex: 'uploaded_by',
      key: 'uploaded_by',
      showSorterTooltip: false
    },
    {
      title: () => (
        <>
          <Row align="middle" justify="space-between" wrap={false}>
            <div>Uploaded Date</div>
          </Row>
        </>
      ),
      sortOrder: sortState.attribute !== 'uploaded_at' ? 'asc' : sortState.direction,
      onHeaderCell: (col) => ({
        style: { cursor: 'pointer' },
        onClick: () => {
          setSortState((pre) => ({
            ...pre,
            attribute: 'uploaded_at',
            direction:
              pre.attribute !== 'uploaded_at' ? 'asc' : col.sortOrder === 'asc' ? 'desc' : 'asc'
          }));
        }
      }),
      sortDirections: ['asc', 'desc', 'asc'],
      dataIndex: 'uploaded_at',
      render: (item, record) => (
        <Col>
          <div>{record.uploaded_at}</div>
        </Col>
      ),
      key: 'uploaded_at',
      showSorterTooltip: false
    },
    {
      title: 'Actions',
      key: 'action',
      render: (item, record) => (
        <>
          <Dropdown
            overlayClassName="more-dropdown-wrap"
            placement="bottomRight"
            menu={{
              items: items(item, record)
            }}>
            <Button
              className="d-flex align-items-center"
              style={{
                borderRadius: '4px',
                background: '#ECECEC',
                border: 'none',
                justifyContent: 'space-evenly'
              }}
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none">
                  <g clipPath="url(#clip0_7907_35839)">
                    <path
                      d="M11.0124 9.99992C11.0124 9.53968 10.6393 9.16659 10.179 9.16659C9.7188 9.16659 9.3457 9.53968 9.3457 9.99992C9.3457 10.4602 9.7188 10.8333 10.179 10.8333C10.6393 10.8333 11.0124 10.4602 11.0124 9.99992Z"
                      fill="#080808"
                      stroke="#080808"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M16.8459 9.99992C16.8459 9.53968 16.4728 9.16659 16.0125 9.16659C15.5523 9.16659 15.1792 9.53968 15.1792 9.99992C15.1792 10.4602 15.5523 10.8333 16.0125 10.8333C16.4728 10.8333 16.8459 10.4602 16.8459 9.99992Z"
                      fill="#080808"
                      stroke="#080808"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M5.17936 9.99992C5.17936 9.53968 4.80627 9.16659 4.34603 9.16659C3.88579 9.16659 3.5127 9.53968 3.5127 9.99992C3.5127 10.4602 3.88579 10.8333 4.34603 10.8333C4.80627 10.8333 5.17936 10.4602 5.17936 9.99992Z"
                      fill="#080808"
                      stroke="#080808"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_7907_35839">
                      <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="matrix(0 -1 1 0 0.179199 20)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              }
            />
          </Dropdown>
        </>
      ),
      fixed: 'right',
      width: 100
    }
  ].filter((col) => !isLookahead || !['duration', 'start_date', 'end_date'].includes(col.key));
  const handleOnChange = (pagination) => {
    setFilterState((prev) => ({
      ...prev,
      page: pagination.current,
      per_page: pagination.pageSize || 5
    }));
  };
  return (
    <div className="rfi-table">
      <Table
        dataSource={dataSource}
        columns={columns}
        childrenColumnName="__disabledChildren"
        onChange={handleOnChange}
        locale={locale}
        pagination={{
          current: filterState.page,
          pageSize: filterState?.per_page,
          total: totalCount,
          showSizeChanger: true
        }}
      />
    </div>
  );
};

export default List;
